import { render, staticRenderFns } from "./autograp.vue?vue&type=template&id=04b94464&scoped=true"
import script from "./autograp.vue?vue&type=script&lang=js"
export * from "./autograp.vue?vue&type=script&lang=js"
import style0 from "./autograp.vue?vue&type=style&index=0&id=04b94464&prod&rel=stylesheet%2Fstylus&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b94464",
  null
  
)

export default component.exports